export default "{\n    \"getPaidOn\": \"Soyez payé le {{date}}\"\n}\n"